import { _keys, generateArray, tsValidateRegexp, tsValidateResult, tsValidateString, tsValidateStringMinLength } from '@nu-art/ts-common';
import { PasswordAssertionType_CapitalLetters, PasswordAssertionType_LowerCaseLetters, PasswordAssertionType_MaxLength, PasswordAssertionType_MinLength, PasswordAssertionType_Numbers, PasswordAssertionType_SpecialChars, PasswordAssertionTypes } from './types.js';
const specialChars = '.*?[!@#$%^&*()_\\+\\-=\\[\\]{},.\\/;\':"<> |\\\\]';
const numbers = '.*?[0-9]';
const lowerCaseLetters = '.*?[a-z]';
const capitalLetters = '.*?[A-Z]';
const Validator_PasswordAssertion = {
    [PasswordAssertionType_MinLength]: (amount) => tsValidateStringMinLength(amount),
    [PasswordAssertionType_MaxLength]: (amount) => tsValidateString(amount),
    [PasswordAssertionType_SpecialChars]: (amount) => tsValidateRegexp(new RegExp(generateArray(amount, _ => specialChars).join(''))),
    [PasswordAssertionType_Numbers]: (amount) => tsValidateRegexp(new RegExp(generateArray(amount, _ => numbers).join(''))),
    [PasswordAssertionType_LowerCaseLetters]: (amount) => tsValidateRegexp(new RegExp(generateArray(amount, _ => lowerCaseLetters).join(''))),
    [PasswordAssertionType_CapitalLetters]: (amount) => tsValidateRegexp(new RegExp(generateArray(amount, _ => capitalLetters).join(''))),
};
const PasswordFailureMessages = {
    [PasswordAssertionType_MinLength]: (amount) => `Password is shorter than ${amount} characters`,
    [PasswordAssertionType_MaxLength]: (amount) => `Password is longer than ${amount} characters`,
    [PasswordAssertionType_SpecialChars]: (amount) => `Password does not contain at least ${amount} special characters`,
    [PasswordAssertionType_Numbers]: (amount) => `Password does not contain at least ${amount} numbers`,
    [PasswordAssertionType_LowerCaseLetters]: (amount) => `Password does not contain at least ${amount} lower case characters`,
    [PasswordAssertionType_CapitalLetters]: (amount) => `Password does not contain at least ${amount} capital letters`,
};
export const assertPasswordRules = (password, assertionConfig) => {
    if (!assertionConfig)
        return;
    const results = _keys(assertionConfig).reduce((results, assertionKey) => {
        if (!PasswordAssertionTypes.includes(assertionKey)) {
            results[assertionKey] = `Unknown assertion key ${assertionKey}`;
            return results;
        }
        const amount = assertionConfig[assertionKey];
        const validator = Validator_PasswordAssertion[assertionKey](amount);
        const result = tsValidateResult(password, validator);
        if (result)
            results[assertionKey] = PasswordFailureMessages[assertionKey](amount);
        return results;
    }, {});
    return _keys(results).length ? results : undefined;
};
//# sourceMappingURL=validator.js.map